<template>
    <div>
        <rkm-form ref="RkmForm">

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        label="Tipo de empréstimo"
                        v-model="model.tipo"
                        :validations="validations.tipo"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Valor da parcela"
                        ref="valorParcela"
                        v-model="model.valorParcela"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.valorParcela"
                        key="valorParcela"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Total de parcelas"
                        v-model="model.quantidadeParcela"
                        :validations="validations.quantidadeParcela"
                        number
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

//Directives
import { VMoney } from 'v-money'

export default {
    directives: { money: VMoney },
    computed: {
        validations() {
            return {
                tipo: { required: true },
                valorParcela: { required: true },
                quantidadeParcela: { required: true, min_value: 1 },
            }
        },
    },
    data: () => ({
        model: {
            tipo: null,
            valorParcela: null,
            quantidadeParcela: null,
        },
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 2,
            masked: false
        },
    }),
    methods: {
        setModel(model) {

            this.model = model

            this.$refs.valorParcela.$el.getElementsByTagName('input')[0].value = model.valorParcela
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {

                if (response === true) {

                    const data = {
                        index: this.index,
                        tipo: this.model.tipo,
                        valorParcela: this.model.valorParcela,
                        quantidadeParcela: this.model.quantidadeParcela,
                    }

                    if (this.data.model.emprestimos.length !== this.index) {
                        Object.assign(this.data.model.emprestimos[this.index], data)
                    } else {
                        this.data.model.emprestimos.push(data)
                    }

                    this.$emit('save', data)
                }
            })
        },
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, required: true },
    },
}
</script>